import React from "react";
import { CategoryTabsProps } from "@/types/news";
/**
 * CategoryTabs Component
 *
 * Renders a horizontally scrollable list of category tabs.
 * Highlights the active tab and triggers a callback when a tab is clicked.
 */
export const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="flex items-center gap-1 overflow-x-auto text-[14px] font-[var(--font-bold)] md:text-[20px]">
      {categories.map((category) => (
        <button
          key={category.value}
          className={`border-t border-r border-l border-[var(--stroke-gray-lighter)] px-3 py-1 whitespace-nowrap hover:cursor-pointer md:px-5 md:py-2 ${
            activeTab === category.value
              ? "border-none bg-[var(--stroke-gray-light)]"
              : "text-[var(--text-gray-normal)]"
          }`}
          onClick={() => onTabChange(category.value)}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
};
